/**
 * 大用户管理模块（src/views/LargeUserManagement）英文映射
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 * 术语：大用户=Large Customer，用水监测=Water Usage Monitoring，用水户=Customer，表具=Meter
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js）──
  '确定': 'OK',
  '取消': 'Cancel',
  '关闭': 'Close',
  '查询': 'Query',
  '重置': 'Reset',
  '详情': 'Details',
  '操作': 'Action',
  '导出': 'Export',
  '其他': 'Other',
  '展开': 'Expand',
  '收起': 'Collapse',
  '折叠': 'Collapse',
  '全部': 'All',
  '新增': 'Add',
  '选择': 'Select',
  '当前选择：': 'Currently selected:',
  '取消选择': 'Deselect',
  // ── 区域树 / 查询条件 ──
  '请输入区域名称': 'Please enter area name',
  '区域名称': 'Area Name',
  '距今': 'From Now',
  '未上报天数': 'Days Not Reported',
  '天': 'Day',
  '元': 'CNY',
  '个': 'pcs',
  '条': ' records',
  '按年': 'Yearly',
  '按月': 'Monthly',
  '分析类型': 'Analysis Type',
  '年月选择': 'Year/Month Selection',
  '日期选择': 'Date Selection',
  '查询起始日': 'Start Date',
  '查询结束日': 'End Date',
  '查询起始时间': 'Start time',
  '查询结束时间': 'End time',
  '请选择开始月份': 'Please select start month',
  '请选择结束月份': 'Please select end month',
  '上报时间': 'Report Time',
  '表编号': 'Meter No.',
  '表编号模糊查询': 'Search by meter no.',
  '输入表编号模糊查询': 'Enter meter no. to search',
  '表口径': 'Meter Caliber',
  '请选择表口径': 'Please select meter caliber',
  '表类型': 'Meter Type',
  '请表类型': 'Select meter type',
  '请选择表类型': 'Select meter type',
  '用户编号': 'Customer No.',
  '用户编号模糊查询': 'Search by customer no.',
  '用户姓名': 'Customer Name',
  '用户姓名模糊查询': 'Search by customer name',
  '用户地址': 'Customer Address',
  '用户地址模糊查询': 'Search by customer address',
  '用户类型': 'Customer Type',
  '请选择用户类型': 'Please select customer type',
  '请选择处理状态': 'Please select handling status',
  '故障类型': 'Fault Type',
  '请选择故障类型': 'Please select fault type',
  // ── tab / 页签 ──
  '选择用户': 'Select Customer',
  '比对分析': 'Comparison Analysis',
  '告警': 'Alarms',
  '不上报': 'Not Reported',
  '设备列表': 'Device List',
  '厂商对比': 'Manufacturer Comparison',
  '用户分析': 'Customer Analysis',
  '请选择用户！': 'Please select a customer!',
  '最多只能选择5个用户比对！': 'Up to 5 customers can be selected for comparison!',
  '请选择分析时间！': 'Please select analysis time!',
  '处理异常': 'Handle Exception',
  // ── 统计卡片 ──
  '总用水量': 'Total Water Consumption',
  '平均流量': 'Average Flow',
  '设备上报率': 'Device Reporting Rate',
  '告警数量': 'Alarm Count',
  '当前余额': 'Current Balance',
  '累计流量': 'Cumulative Flow',
  '当前用水量': 'Current Water Consumption',
  '阀门状态': 'Valve Status',
  '昨日用水量': "Yesterday's Water Consumption",
  '变化率': 'Change Rate',
  '近三日上报率': '3-Day Reporting Rate',
  '开阀/关阀': 'Valve Open/Close',
  '未上报设备数': 'Devices Not Reported',
  '表总数量': 'Total Meters',
  // ── 表头 ──
  '日期': 'Date',
  '日用量': 'Daily Usage',
  '处理状态': 'Handling Status',
  '厂商设备对比': 'Manufacturer Device Comparison',
  '未上报查询': 'Not Reported Query',
  '请输入表编号': 'Please enter meter No.',
  '请选择操作员': 'Please select operator',
  '请选择维修时间': 'Please select repair time',
  '请选择维修类型': 'Please select repair type',
  '排名': 'Rank',
  '当前年度总用水量': 'Current Year Total Water Consumption',
  '上年度总用水量': 'Last Year Total Water Consumption',
  '当前月度总用水量': 'Current Month Total Water Consumption',
  '上月度总用水量': 'Last Month Total Water Consumption',
  '同比变化量': 'YoY Change',
  '同比变化百分比': 'YoY Change (%)',
  '异常标记': 'Abnormal Flag',
  '用户名称': 'Customer Name',
  '安装地址': 'Installation Address',
  '累计流量(m³)': 'Cumulative Flow (m³)',
  '用户状态': 'Customer Status',
  '昨日用水量(m³)': "Yesterday's Water Consumption (m³)",
  '变动百分比': 'Change Percentage',
  '最后上报时间': 'Last Report Time',
  '最近上报时间': 'Last Report Time',
  '最近上报总用量(m³)': 'Last Reported Total Usage (m³)',
  '最近上报阀门状态': 'Last Valve Status',
  '电池状态': 'Battery Status',
  '表安装地址': 'Meter Installation Address',
  '用户余额(元)': 'Customer Balance (CNY)',
  '用户手机号': 'Customer Mobile Phone',
  '处理进度': 'Handling Progress',
  '本轮告警次数': 'Alarm Count This Round',
  '总告警次数': 'Total Alarm Count',
  '最新告警时间': 'Latest Alarm Time',
  '本轮告警起始时间': 'Current Alarm Round Start Time',
  '处理时间': 'Handling Time',
  '处理人': 'Handler',
  '厂商名称': 'Manufacturer Name',
  '设备总数': 'Total Devices',
  '正常设备数': 'Normal Device Count',
  '上报率': 'Reporting Rate',
  '上报率(%)': 'Reporting Rate (%)',
  '数量(只)': 'Quantity (pcs)',
  '已激活': 'Activated',
  '未激活': 'Not Activated',
  '未处理': 'Unprocessed',
  '处理中': 'Processing',
  '已处理': 'Processed',
  '处理': 'Handle',
  '未知': 'Unknown',
  '正常': 'Normal',
  '欠压': 'Undervoltage',
  // ── 详情弹窗（用户分析）──
  '用户信息': 'Customer Info',
  '用水性质': 'Water Use Category',
  '身份类型': 'Identity Type',
  '自然人': 'Natural Person',
  '企业': 'Enterprise',
  '建档时间': 'Filing Time',
  '水表信息': 'Water Meter Info',
  '出厂时间': 'Production Time',
  '表厂家': 'Meter Manufacturer',
  '地理信息': 'Geographic Info',
  '用户经度': 'Customer Longitude',
  '用户纬度': 'Customer Latitude',
  '表具状态': 'Meter Status',
  '历史用水量曲线': 'Historical Water Consumption Curve',
  '最大值': 'Max',
  '最小值': 'Min',
  '平均值': 'Average',
  // ── 图表 ──
  '多用户同比分析': 'Multi-Customer YoY Analysis',
  '多用户环比分析': 'Multi-Customer MoM Analysis',
  '异常状态': 'Exception Status',
  // ── 故障类型枚举（meterWarnTypeObj）──
  '电池欠压': 'Battery Undervoltage',
  '磁干扰': 'Magnetic Interference',
  '存储器故障': 'Memory Fault',
  '逆流故障': 'Reverse Flow Fault',
  '阀门故障': 'Valve Fault',
  // ── 阀门状态枚举（Mn100FkStatusObj）──
  '关阀': 'Close Valve',
  '开阀': 'Open Valve',
  '强制开阀': 'Force Open Valve',
  '强制关阀': 'Force Close Valve',
  '阀门开故障': 'Valve Open Fault',
  '阀门关故障': 'Valve Close Fault',
  '无阀': 'No Valve',
  '阀门锈死故障': 'Rusted Valve Fault',
}
